export const INITIAL_LOADER_MESSAGE = "Internets at work...";
